module.exports = __webpack_public_path__ + "static/media/eposspea.a8da50b0.JPG";